// extracted by mini-css-extract-plugin
export default {"manager_tagged":"XTags_manager_tagged__MSFdN","dark":"XTags_dark__Zvths","active":"XTags_active__-uBQd"};